export function SectionHeading({ eyebrow, title, subtitle, align = "left", testId }) {
  const al = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${al}`} data-testid={testId}>
      {eyebrow && (
        <div className={`inline-flex items-center gap-2 mb-4 ${align === "center" ? "justify-center" : ""}`}>
          <span className="h-px w-8 bg-[#FBBF24]" />
          <span className="text-xs uppercase tracking-[0.18em] font-semibold text-[#FBBF24]">{eyebrow}</span>
        </div>
      )}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">{subtitle}</p>
      )}
    </div>
  );
}
